module.exports = __webpack_public_path__ + "img/bg-head.66184561.png";